/**
 * SECHI-SUGGERIMENTI (26/09/2026) — suggerimenti mentre si scrive nelle NOSTRE barre di ricerca
 * («Cerca nel negozio online…» nell'intestazione, «Cerca un prodotto, una misura, una marca…» in homepage), che sono
 * moduli semplici: prima i risultati comparivano solo premendo invio (Daniele: «non escono risultati quando scrivo»).
 * Usa il servizio di Shopify /search/suggest.json (lo stesso della lente del tema). Invio = ricerca completa come prima
 * (sinonimi di sechi-ricerca.js compresi). La finestra della lente del tema (predictive-search) non si tocca.
 * Annullare: togliere la riga con 'sechi-suggerimenti.js' da layout/theme.liquid.
 */
(function () {
  'use strict';
  var campi = Array.prototype.filter.call(document.querySelectorAll('form[action="/search"] input[name="q"]'), function (i) { return !i.closest('predictive-search'); });
  if (!campi.length) return;

  var st = document.createElement('style');
  st.textContent =
    '.sechi-sug{position:absolute;left:0;right:0;top:100%;z-index:60;background:#fff;color:#1d2a33;border:1px solid #cfd8dd;border-radius:0 0 8px 8px;box-shadow:0 10px 24px rgba(0,0,0,.15);max-height:70vh;overflow-y:auto;text-align:left;font-size:15px;line-height:1.3}' +
    '.sechi-sug a{display:flex;gap:10px;align-items:center;padding:8px 12px;color:inherit;text-decoration:none;border-top:1px solid #eef2f4}' +
    '.sechi-sug a:first-child{border-top:0}' +
    '.sechi-sug a.att,.sechi-sug a:hover{background:#eef4f7}' +
    '.sechi-sug img{width:44px;height:44px;object-fit:contain;flex:0 0 44px;background:#f5f7f8;border-radius:4px}' +
    '.sechi-sug .t{flex:1;min-width:0}' +
    '.sechi-sug .p{font-weight:600;white-space:nowrap}' +
    '.sechi-sug .e{font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#6a7a84;padding:8px 12px 2px}' +
    '.sechi-sug .tutti{font-weight:600;color:#1f4e6b}' +
    '.sechi-sug .vuoto{padding:10px 12px;color:#6a7a84}';
  document.head.appendChild(st);

  function euro(v) { var n = Number(v); return isNaN(n) ? '' : n.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=100'; }

  campi.forEach(function (campo) {
    var form = campo.form; if (!form) return;
    if (getComputedStyle(form).position === 'static') form.style.position = 'relative';
    var box = document.createElement('div'); box.className = 'sechi-sug'; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    campo.setAttribute('autocomplete', 'off');
    var timer = null, ultima = '', ctrl = null, att = -1;

    function chiudi() { box.hidden = true; att = -1; }
    function voci() { return box.querySelectorAll('a'); }
    function evidenzia(n) { var v = voci(); if (!v.length) return; att = (n + v.length) % v.length; Array.prototype.forEach.call(v, function (a, i) { a.classList.toggle('att', i === att); }); v[att].scrollIntoView({ block: 'nearest' }); }
    function riga(href, testo, prezzo, foto) {
      var a = document.createElement('a'); a.href = href; a.setAttribute('role', 'option');
      if (foto !== undefined) { var im = document.createElement('img'); im.alt = ''; if (foto) im.src = img(foto); a.appendChild(im); }
      var t = document.createElement('span'); t.className = 't'; t.textContent = testo; a.appendChild(t);
      if (prezzo) { var p = document.createElement('span'); p.className = 'p'; p.textContent = prezzo; a.appendChild(p); }
      return a;
    }
    function mostra(q, r) {
      box.textContent = ''; att = -1;
      var prod = (r && r.products) || [], coll = (r && r.collections) || [];
      if (coll.length) {
        var e1 = document.createElement('div'); e1.className = 'e'; e1.textContent = 'Reparti'; box.appendChild(e1);
        coll.slice(0, 3).forEach(function (c) { box.appendChild(riga(c.url, c.title)); });
      }
      if (prod.length) {
        var e2 = document.createElement('div'); e2.className = 'e'; e2.textContent = 'Prodotti'; box.appendChild(e2);
        prod.forEach(function (p) { box.appendChild(riga(p.url, p.title, euro(p.price), (p.featured_image && p.featured_image.url) || p.image || '')); });
      }
      if (!prod.length && !coll.length) { var v = document.createElement('div'); v.className = 'vuoto'; v.textContent = 'Nessun suggerimento: premi invio per cercare «' + q + '».'; box.appendChild(v); }
      var tutti = riga('/search?q=' + encodeURIComponent(q), 'Vedi tutti i risultati per «' + q + '»'); tutti.classList.add('tutti'); box.appendChild(tutti);
      box.hidden = false;
    }
    function cerca() {
      var q = campo.value.trim();
      if (q.length < 2) { ultima = q; chiudi(); return; }
      if (q === ultima && !box.hidden) return;
      ultima = q;
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (x) { return x.json(); }).then(function (j) {
        if (campo.value.trim() !== q) return;
        mostra(q, j && j.resources && j.resources.results);
      }).catch(function () {});
    }
    campo.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(cerca, 180); });
    campo.addEventListener('focus', function () { if (campo.value.trim().length >= 2) { ultima = ''; cerca(); } });
    campo.addEventListener('keydown', function (ev) {
      if (box.hidden) return;
      if (ev.key === 'ArrowDown') { ev.preventDefault(); evidenzia(att + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); evidenzia(att - 1); }
      else if (ev.key === 'Escape') { chiudi(); }
      else if (ev.key === 'Enter' && att >= 0) { ev.preventDefault(); window.location.href = voci()[att].href; }
    });
    document.addEventListener('click', function (ev) { if (!form.contains(ev.target)) chiudi(); });
  });
})();
